import Axios from "helpers/Interceptor";
import { BrandContent } from "modules/Types";

/** 
 * Searches for Spotify releases by URL and returns content metadata
 * @param spotifyUrl - The Spotify URL to search for (track, album, or playlist)
 * @returns Promise resolving to content data or null if not found/error
 */
export const searchSpotifyReleases = async (spotifyUrl: string): Promise<BrandContent | null> => {
    try {
        const endpoint = 'platform/identify/content'
        const response = await Axios.get<BrandContent>(endpoint, {
            params: { 
                url: encodeURIComponent(spotifyUrl)
            }
        });
        
        return response?.data || null
    } catch (error) {
        console.error('Error searching Spotify releases:', error)
        return null
    }
};

/** 
 * Searches for Spotify releases by URL using the unprotected AdBox endpoint
 * @param spotifyUrl - The Spotify URL to search for (track, album, or playlist)
 * @returns Promise resolving to content data or null if not found/error
 */
export const searchSpotifyReleasesAdBox = async (spotifyUrl: string): Promise<{
    type: string;
    spotify_release_type: string | null;
    spotify_id: string;
    thumbnail_url: string;
    name: string;
    release_date: string;
    spotify_uri: string;
    record_url: string;
    primary_artist: string;
    explicit: boolean;
    external_ids: {
        isrc: string;
    };
    preview_url: string;
    external_links: Array<{
        name: string;
        url: string;
    }>;
} | null> => {
    try {
        const endpoint = 'platform/adbox/identify/content'
        const response = await Axios.get(endpoint, {
            params: {
                url: spotifyUrl
            }
        });

        if (response?.data?.isError) {
            console.error('AdBox API error:', response.data.message);
            return null;
        }
        return response?.data || null
    } catch (error) {
        console.error('Error searching Spotify releases (AdBox):', error)
        return null
    }
};
